import isEqual from "lodash/isEqual";

import { useListContext, useListParams } from "@/modules/list";

import { filterSortKeys } from "./list-reset-actions.helper";

export const useListResetActions = () => {
  const { filters, sort } = useListParams();
  const {
    defaultSort,
    tableColumnsKeys,
    clearFiltersAndSorts,
    resetFiltersAndSorts,
  } = useListContext();

  const visibleSorts = filterSortKeys(sort, tableColumnsKeys);
  const visibleDefaultSorts = filterSortKeys(defaultSort, tableColumnsKeys);

  const hasFilters = Object.keys(filters).length > 0;
  const hasSorts = visibleSorts.length > 0;

  const isDefaultSort = isEqual(visibleSorts, visibleDefaultSorts);
  const isDefaultState = isDefaultSort && !hasFilters;

  const noFilterSort = !hasFilters && !hasSorts;

  const onResetClick = () => {
    resetFiltersAndSorts();
  };

  const onDeleteClick = () => {
    clearFiltersAndSorts();
  };

  return {
    noFilterSort,
    resetButton: {
      onClick: onResetClick,
      disabled: isDefaultState,
    },
    deleteButton: {
      onClick: onDeleteClick,
      disabled: noFilterSort,
    },
  };
};
